export default function () {
    return !!window?.appConfig?.newCategoriesGrouping;
}